import { applyActionCode } from 'firebase/auth';

import { getAuthentication } from './helpers';

export const verifyEmail = async (actionCode: string) => {
  const auth = await getAuthentication();
  return applyActionCode(auth, actionCode);
};
